import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { PosMatchineComponent } from './modules/auth/components/pos-matchine/pos-matchine.component';
import { PosCustomerDisplayComponent } from './pos-customer-display/pos-customer-display.component';
import { AuthGuardService } from './services/guards/auth-guard.service';
import { MobileGuard } from './services/guards/mobile.guard';
import { PinRecoveryComponent } from './pin-recovery/pin-recovery.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'mobile',
    loadChildren: () => import('./mobile/mobile.module').then((m) => m.MobileModule),
    canActivate: [MobileGuard],
  },
  {
    path: 'pos',
    loadChildren: () => import('./pos/pos.module').then((m) => m.PosModule),
    canActivate: [AuthGuardService],
  },
  { path: 'pos-customer', component: PosCustomerDisplayComponent },
  { path: 'pin-recovery', component: PinRecoveryComponent },
  { path: 'pos-matchine', component: PosMatchineComponent },
  {
    path: '',
    loadChildren: () => import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuardService],
  },

  { path: 'setting', loadChildren: () => import('./pages/setting/setting.module').then((m) => m.SettingModule) },
  {
    path: 'general-setting',
    loadChildren: () =>
      import('./pages/setting/general-setting/general-setting.module').then((m) => m.GeneralSettingModule),
  },
  {
    path: 'general-information',
    loadChildren: () =>
      import('./pages/setting/general-setting/general-information/general-information.module').then(
        (m) => m.GeneralInformationModule
      ),
  },
  {
    path: 'customer-information',
    loadChildren: () =>
      import('./pages/setting/general-setting/customer-information/customer-information.module').then(
        (m) => m.CustomerInformationModule
      ),
  },
  {
    path: 'dealer-information',
    loadChildren: () =>
      import('./pages/setting/general-setting/dealer-information/dealer-information.module').then(
        (m) => m.DealerInformationModule
      ),
  },
  {
    path: 'bank-account-information',
    loadChildren: () =>
      import('./pages/setting/general-setting/bank-account-information/bank-account-information.module').then(
        (m) => m.BankAccountInformationModule
      ),
  },
  {
    path: 'config-expense',
    loadChildren: () =>
      import('./pages/setting/general-setting/config-expense/config-expense.module').then((m) => m.ConfigExpenseModule),
  },
  {
    path: 'employee-setting',
    loadChildren: () =>
      import('./pages/setting/employee-setting/employee-setting.module').then((m) => m.EmployeeSettingModule),
  },
  {
    path: 'employee-information',
    loadChildren: () =>
      import('./pages/setting/employee-setting/employee-information/employee-information.module').then(
        (m) => m.EmployeeInformationModule
      ),
  },
  {
    path: 'permission',
    loadChildren: () =>
      import('./pages/setting/employee-setting/permission/permission.module').then((m) => m.PermissionModule),
  },
  {
    path: 'ingredient-product-setting',
    loadChildren: () =>
      import('./pages/setting/ingredient-product-setting/ingredient-product-setting.module').then(
        (m) => m.IngredientProductSettingModule
      ),
  },
  {
    path: 'unit',
    loadChildren: () => import('./pages/setting/ingredient-product-setting/unit/unit.module').then((m) => m.UnitModule),
  },
  {
    path: 'ingredient-product-type',
    loadChildren: () =>
      import('./pages/setting/ingredient-product-setting/ingredient-product-type/ingredient-product-type.module').then(
        (m) => m.IngredientProductTypeModule
      ),
  },
  {
    path: 'ingredient-product-list',
    loadChildren: () =>
      import('./pages/setting/ingredient-product-setting/ingredient-product-list/ingredient-product-list.module').then(
        (m) => m.IngredientProductListModule
      ),
  },
  {
    path: 'default-setting',
    loadChildren: () =>
      import('./pages/setting/default-setting/default-setting.module').then((m) => m.DefaultSettingModule),
  },
  {
    path: 'partner-setting',
    loadChildren: () =>
      import('./pages/setting/partner-setting/partner-setting.module').then((m) => m.PartnerSettingModule),
  },
  {
    path: 'expenses-external-setting',
    loadChildren: () =>
      import('./pages/setting/expenses-external-setting/expenses-external-setting.module').then(
        (m) => m.ExpensesExternalSettingModule
      ),
  },
  {
    path: 'cash-default',
    loadChildren: () =>
      import('./pages/setting/default-setting/cash-default/cash-default.module').then((m) => m.CashDefaultModule),
  },
  {
    path: 'ingredient-product-default',
    loadChildren: () =>
      import('./pages/setting/default-setting/ingredient-product-default/ingredient-product-default.module').then(
        (m) => m.IngredientProductDefaultModule
      ),
  },
  {
    path: 'expenses-external-information',
    loadChildren: () =>
      import(
        './pages/setting/expenses-external-setting/expenses-external-information/expenses-external-information.module'
      ).then((m) => m.ExpensesExternalInformationModule),
  },
  {
    path: 'membership-onformation',
    loadChildren: () =>
      import('./pages/setting/partner-setting/membership-information/membership-information.module').then(
        (m) => m.MembershipInformationModule
      ),
  },
  {
    path: 'dividend-ratio',
    loadChildren: () =>
      import('./pages/setting/partner-setting/dividend-ratio/dividend-ratio.module').then((m) => m.DividendRatioModule),
  },
  {
    path: 'member-information',
    loadChildren: () =>
      import('./pages/member-information/member-information.module').then((m) => m.MemberInformationModule),
  },
  {
    path: 'farm-information',
    loadChildren: () =>
      import('./pages/member-information/farm-information/farm-information.module').then(
        (m) => m.FarmInformationModule
      ),
  },
  {
    path: 'agent-information',
    loadChildren: () =>
      import('./pages/member-information/agent-information/agent-information.module').then(
        (m) => m.AgentInformationModule
      ),
  },
  {
    path: 'raw-material',
    loadChildren: () => import('./pages/raw-material/raw-material.module').then((m) => m.RawMaterialModule),
  },
  {
    path: 'purchase-order',
    loadChildren: () =>
      import('./pages/raw-material/purchase-order/purchase-order.module').then((m) => m.PurchaseOrderModule),
  },
  {
    path: 'raw-material-claim',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-claim/raw-material-claim.module').then((m) => m.RawMaterialClaimModule),
  },
  {
    path: 'raw-material-return',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-return/raw-material-return.module').then(
        (m) => m.RawMaterialReturnModule
      ),
  },
  {
    path: 'raw-material-requisition',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-requisition/raw-material-requisition.module').then(
        (m) => m.RawMaterialRequisitionModule
      ),
  },
  {
    path: 'raw-material-receiving',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-receiving/raw-material-receiving.module').then(
        (m) => m.RawMaterialReceivingModule
      ),
  },
  {
    path: 'stock-adjust',
    loadChildren: () =>
      import('./pages/raw-material/stock-adjust/stock-adjust.module').then((m) => m.StockAdjustModule),
  },
  {
    path: 'raw-material-sell',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-sell/raw-material-sell.module').then((m) => m.RawMaterialSellModule),
  },
  {
    path: 'raw-material-buy',
    loadChildren: () =>
      import('./pages/raw-material/raw-material-buy/raw-material-buy.module').then((m) => m.RawMaterialBuyModule),
  },
  {
    path: 'manage-farming',
    loadChildren: () => import('./pages/manage-farming/manage-farming.module').then((m) => m.ManageFarmingModule),
  },
  {
    path: 'farming-type',
    loadChildren: () =>
      import('./pages/manage-farming/farming-type/farming-type.module').then((m) => m.FarmingTypeModule),
  },
  {
    path: 'farming-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/farming-information.module').then(
        (m) => m.FarmingInformationModule
      ),
  },
  {
    path: 'farming-activity',
    loadChildren: () =>
      import('./pages/manage-farming/farming-type/farming-activity/farming-activity.module').then(
        (m) => m.FarmingActivityModule
      ),
  },
  {
    path: 'farming-type',
    loadChildren: () =>
      import('./pages/manage-farming/farming-type/farming-type/farming-type.module').then((m) => m.FarmingTypeModule),
  },
  {
    path: 'activity-type',
    loadChildren: () =>
      import('./pages/manage-farming/farming-type/activity-type/activity-type.module').then(
        (m) => m.ActivityTypeModule
      ),
  },
  {
    path: 'farming-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/farming-information/farming-information.module').then(
        (m) => m.FarmingInformationModule
      ),
  },
  {
    path: 'expense-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/expense-information/expense-information.module').then(
        (m) => m.ExpenseInformationModule
      ),
  },
  {
    path: 'environment-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/environment-information/environment-information.module').then(
        (m) => m.EnvironmentInformationModule
      ),
  },
  {
    path: 'wasting-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/wasting-information/wasting-information.module').then(
        (m) => m.WastingInformationModule
      ),
  },
  {
    path: 'growth-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/growth-information/growth-information.module').then(
        (m) => m.GrowthInformationModule
      ),
  },
  {
    path: 'harvest-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-information/harvest-information/harvest-information.module').then(
        (m) => m.HarvestInformationModule
      ),
  },
  {
    path: 'contract-lot-management',
    loadChildren: () =>
      import('./pages/contract-lot-management/contract-lot-management.module').then(
        (m) => m.ContractLotManagementModule
      ),
  },
  {
    path: 'contract-information',
    loadChildren: () =>
      import('./pages/contract-lot-management/contract-information/contract-information.module').then(
        (m) => m.ContractInformationModule
      ),
  },
  {
    path: 'lot-information',
    loadChildren: () =>
      import('./pages/contract-lot-management/lot-information/lot-information.module').then(
        (m) => m.LotInformationModule
      ),
  },
  {
    path: 'other-income',
    loadChildren: () =>
      import('./pages/setting/general-setting/other-income/other-income.module').then((m) => m.OtherIncomeModule),
  },
  {
    path: 'account-setting',
    loadChildren: () => import('./pages/account-setting/account-setting.module').then((m) => m.AccountSettingModule),
  },
  {
    path: 'expenses',
    loadChildren: () => import('./pages/account-setting/expenses/expenses.module').then((m) => m.ExpensesModule),
  },
  {
    path: 'accept-debt',
    loadChildren: () =>
      import('./pages/account-setting/accept-debt/accept-debt.module').then((m) => m.AcceptDebtModule),
  },
  {
    path: 'pay-off-debt',
    loadChildren: () =>
      import('./pages/account-setting/pay-off-debt/pay-off-debt.module').then((m) => m.PayOffDebtModule),
  },
  {
    path: 'employee-wages',
    loadChildren: () =>
      import('./pages/account-setting/employee-wages/employee-wages.module').then((m) => m.EmployeeWagesModule),
  },
  {
    path: 'member-dividend-payment',
    loadChildren: () =>
      import('./pages/account-setting/member-dividend-payment/member-dividend-payment.module').then(
        (m) => m.MemberDividendPaymentModule
      ),
  },
  {
    path: 'other-income',
    loadChildren: () =>
      import('./pages/account-setting/other-income/other-income.module').then((m) => m.OtherIncomeModule),
  },
  {
    path: 'product-cost',
    loadChildren: () =>
      import('./pages/report/production-efficiency/product-cost/product-cost.module').then((m) => m.ProductCostModule),
  },
  {
    path: 'production-efficiency',
    loadChildren: () =>
      import('./pages/report/production-efficiency/production-efficiency.module').then(
        (m) => m.ProductionEfficiencyModule
      ),
  },
  {
    path: 'product-cost',
    loadChildren: () =>
      import('./pages/report/production-efficiency/product-cost/product-cost.module').then((m) => m.ProductCostModule),
  },
  {
    path: 'product-cost-activity-type',
    loadChildren: () =>
      import('./pages/report/production-efficiency/product-cost-activity-type/product-cost-activity-type.module').then(
        (m) => m.ProductCostActivityTypeModule
      ),
  },
  {
    path: 'feed-fertilize-drug',
    loadChildren: () =>
      import('./pages/report/production-efficiency/feed-fertilize-drug/feed-fertilize-drug.module').then(
        (m) => m.FeedFertilizeDrugModule
      ),
  },
  {
    path: 'product-quantity',
    loadChildren: () =>
      import('./pages/report/production-efficiency/product-quantity/product-quantity.module').then(
        (m) => m.ProductQuantityModule
      ),
  },
  {
    path: 'wasting-report',
    loadChildren: () =>
      import('./pages/report/production-efficiency/wasting-report/wasting-report.module').then(
        (m) => m.WastingReportModule
      ),
  },
  {
    path: 'environment-report',
    loadChildren: () =>
      import('./pages/report/environment-report/environment-report.module').then((m) => m.EnvironmentReportModule),
  },
  {
    path: 'environment-value',
    loadChildren: () =>
      import('./pages/report/environment-report/environment-value/environment-value.module').then(
        (m) => m.EnvironmentValueModule
      ),
  },
  {
    path: 'purchase-report',
    loadChildren: () =>
      import('./pages/report/purchase-report/purchase-report.module').then((m) => m.PurchaseReportModule),
  },
  {
    path: 'purchase-raw-material',
    loadChildren: () =>
      import('./pages/report/purchase-report/purchase-raw-material/purchase-raw-material.module').then(
        (m) => m.PurchaseRawMaterialModule
      ),
  },
  {
    path: 'purchase-product',
    loadChildren: () =>
      import('./pages/report/purchase-report/purchase-product/purchase-product.module').then(
        (m) => m.PurchaseProductModule
      ),
  },
  {
    path: 'sales-report',
    loadChildren: () => import('./pages/report/sales-report/sales-report.module').then((m) => m.SalesReportModule),
  },
  {
    path: 'sales-raw-material',
    loadChildren: () =>
      import('./pages/report/sales-report/sales-raw-material/sales-raw-material.module').then(
        (m) => m.SalesRawMaterialModule
      ),
  },
  {
    path: 'sales-product',
    loadChildren: () =>
      import('./pages/report/sales-report/sales-product/sales-product.module').then((m) => m.SalesProductModule),
  },
  {
    path: 'accounting-report',
    loadChildren: () =>
      import('./pages/report/accounting-report/accounting-report.module').then((m) => m.AccountingReportModule),
  },
  {
    path: 'income-statement',
    loadChildren: () =>
      import('./pages/report/accounting-report/income-statement/income-statement.module').then(
        (m) => m.IncomeStatementModule
      ),
  },
  {
    path: 'cash-flow--statement',
    loadChildren: () =>
      import('./pages/report/accounting-report/cash-flow-statement/cash-flow-statement.module').then(
        (m) => m.CashFlowStatementModule
      ),
  },
  {
    path: 'debtor-report',
    loadChildren: () =>
      import('./pages/report/accounting-report/debtor-report/debtor-report.module').then((m) => m.DebtorReportModule),
  },
  {
    path: 'creditor-report',
    loadChildren: () =>
      import('./pages/report/accounting-report/creditor-report/creditor-report.module').then(
        (m) => m.CreditorReportModule
      ),
  },
  {
    path: 'expenses-report',
    loadChildren: () =>
      import('./pages/report/accounting-report/expenses-report/expenses-report.module').then(
        (m) => m.ExpensesReportModule
      ),
  },
  {
    path: 'general-report',
    loadChildren: () =>
      import('./pages/report/general-report/general-report.module').then((m) => m.GeneralReportModule),
  },
  {
    path: 'wage-report',
    loadChildren: () =>
      import('./pages/report/general-report/wage-report/wage-report.module').then((m) => m.WageReportModule),
  },
  {
    path: 'receive-money-report',
    loadChildren: () =>
      import('./pages/report/general-report/receive-money-report/receive-money-report.module').then(
        (m) => m.ReceiveMoneyReportModule
      ),
  },
  {
    path: 'tax-report',
    loadChildren: () =>
      import('./pages/report/general-report/tax-report/tax-report.module').then((m) => m.TaxReportModule),
  },
  {
    path: 'contract-report',
    loadChildren: () =>
      import('./pages/report/general-report/contract-report/contract-report.module').then(
        (m) => m.ContractReportModule
      ),
  },
  {
    path: 'close-lot-report',
    loadChildren: () =>
      import('./pages/report/general-report/close-lot-report/close-lot-report.module').then(
        (m) => m.CloseLotReportModule
      ),
  },
  {
    path: 'pay-dividends-report',
    loadChildren: () =>
      import('./pages/report/general-report/pay-dividends-report/pay-dividends-report.module').then(
        (m) => m.PayDividendsReportModule
      ),
  },
  {
    path: 'analysis-report',
    loadChildren: () =>
      import('./pages/report/analysis-report/analysis-report.module').then((m) => m.AnalysisReportModule),
  },
  {
    path: 'growth-report',
    loadChildren: () =>
      import('./pages/report/production-efficiency/growth-report/growth-report.module').then(
        (m) => m.GrowthReportModule
      ),
  },
  {
    path: 'performance-analysis',
    loadChildren: () =>
      import('./pages/report/analysis-report/performance-analysis/performance-analysis.module').then(
        (m) => m.PerformanceAnalysisModule
      ),
  },
  {
    path: 'farming-report',
    loadChildren: () =>
      import('./pages/report/analysis-report/farming-report/farming-report.module').then((m) => m.FarmingReportModule),
  },
  {
    path: 'purchase-raw-material',
    loadChildren: () =>
      import('./pages/report/analysis-report/purchase-raw-material/purchase-raw-material.module').then(
        (m) => m.PurchaseRawMaterialModule
      ),
  },
  {
    path: 'raw-material-truck',
    loadChildren: () =>
      import('./pages/report/analysis-report/raw-material-truck/raw-material-truck.module').then(
        (m) => m.RawMaterialTruckModule
      ),
  },
  {
    path: 'product-truck',
    loadChildren: () =>
      import('./pages/report/analysis-report/product-truck/product-truck.module').then((m) => m.ProductTruckModule),
  },
  {
    path: 'feed-fertilize',
    loadChildren: () =>
      import('./pages/report/analysis-report/feed-fertilize/feed-fertilize.module').then((m) => m.FeedFertilizeModule),
  },
  {
    path: 'harvest-report',
    loadChildren: () =>
      import('./pages/report/analysis-report/harvest-report/harvest-report.module').then((m) => m.HarvestReportModule),
  },
  {
    path: 'stock-adjustment',
    loadChildren: () =>
      import('./pages/report/analysis-report/stock-adjustment/stock-adjustment.module').then(
        (m) => m.StockAdjustmentModule
      ),
  },
  {
    path: 'cash-flow-mnagement',
    loadChildren: () =>
      import('./pages/report/analysis-report/cash-flow-management/cash-flow-management.module').then(
        (m) => m.CashFlowManagementModule
      ),
  },
  {
    path: 'messages',
    loadChildren: () => import('./pages/member-information/messages/messages.module').then((m) => m.MessagesModule),
  },

  {
    path: 'crop-requirement',
    loadChildren: () =>
      import('./pages/manage-farming/farming-type/crop-requirement/crop-requirement.module').then(
        (m) => m.CropRequirementModule
      ),
  },
  {
    path: 'farming-activity',
    loadChildren: () =>
      import('./pages/manage-farming/farming-activity/farming-activity.module').then((m) => m.FarmingActivityModule),
  },
  {
    path: 'activity-information',
    loadChildren: () =>
      import('./pages/manage-farming/farming-activity/activity-information/activity-information.module').then(
        (m) => m.ActivityInformationModule
      ),
  },
  {
    path: 'production-plan',
    loadChildren: () =>
      import('./pages/manage-farming/production-plan/production-plan.module').then((m) => m.ProductionPlanModule),
  },
  {
    path: 'order-plan',
    loadChildren: () =>
      import('./pages/manage-farming/production-plan/order-plan/order-plan.module').then((m) => m.OrderPlanModule),
  },
  {
    path: 'analyze-orders',
    loadChildren: () =>
      import('./pages/manage-farming/production-plan/analyze-orders/analyze-orders.module').then(
        (m) => m.AnalyzeOrdersModule
      ),
  },
  {
    path: 'report-plan',
    loadChildren: () =>
      import('./pages/manage-farming/production-plan/report-plan/report-plan.module').then((m) => m.ReportPlanModule),
  },
  {
    path: 'pos-setting',
    loadChildren: () => import('./pages/setting/pos-setting/pos-setting.module').then((m) => m.PosSettingModule),
  },
  {
    path: 'warehouse-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/warehouse-setting/warehouse-setting.module').then(
        (m) => m.WarehouseSettingModule
      ),
  },
  {
    path: 'transfer-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/transfer-setting/transfer-setting.module').then(
        (m) => m.TransferSettingModule
      ),
  },
  {
    path: 'menu-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/menu-setting/menu-setting.module').then((m) => m.MenuSettingModule),
  },
  {
    path: 'category-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/category-setting/category-setting.module').then(
        (m) => m.CategorySettingModule
      ),
  },
  {
    path: 'rounding-off-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/rounding-off-setting/rounding-off-setting.module').then(
        (m) => m.RoundingOffSettingModule
      ),
  },
  {
    path: 'cancellation-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/cancellation-setting/cancellation-setting.module').then(
        (m) => m.CancellationSettingModule
      ),
  },
  {
    path: 'printer-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/printer-setting/printer-setting.module').then((m) => m.PrinterSettingModule),
  },
  {
    path: 'pos-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/pos-setting/pos-setting.module').then((m) => m.PosSettingModule),
  },
  {
    path: 'promotion-setting',
    loadChildren: () =>
      import('./pages/setting/pos-setting/promotion-setting/promotion-setting.module').then(
        (m) => m.PromotionSettingModule
      ),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
